import { NodeProps, Node, Edge, EdgeProps } from '@xyflow/react';

export const DefaultNodeType = {
  Basic: 'basic',
  PlaceHolder: 'placeHolder',
} as const;

// Type for all of the values of NodeType
export type DefaultNodeTypes = (typeof DefaultNodeType)[keyof typeof DefaultNodeType];

// This is the type for the custom data added to the nodes under the "data" property.
export type DefaultNodeData = {
  id: string;
  label: string;
  parentId?: string; // set on placeholder nodes
};

// This type is used to define the props that are passed to the nodes in the graph. It is meant
// to be a shared type that can be used for all custom nodes.
export type SharedNodeProps = NodeProps<Node<DefaultNodeData, DefaultNodeTypes>>;

export const EdgeType = {
  Basic: 'basic',
  ToTarget: 'toTarget',
  FromSource: 'fromSource',
  TreeOption: 'treeOption',
  PlaceHolder: 'placeHolder',
} as const;

export type EdgeTypes = (typeof EdgeType)[keyof typeof EdgeType];

export type SharedEdgeProps = EdgeProps<Edge<CustomEdgeData, EdgeTypes>>;

export type CustomEdgeData = {
  label?: string;
  isExtendable?: boolean;
};
